import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { SITE } from "../config";

const GOLD_ART =
  "https://images.unsplash.com/photo-1771747131849-41056d3d9be3?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200";

export const AuthorSection = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], [-40, 60]);

  return (
    <section id="author" ref={ref} data-testid="author-section" className="relative py-24 md:py-40 max-w-[1600px] mx-auto px-6 md:px-12">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-center">
        <div className="lg:col-span-5 order-2 lg:order-1">
          <div className="relative aspect-[4/5] overflow-hidden gold-glow">
            <motion.img
              src={GOLD_ART}
              alt="Abstract golden form"
              style={{ y }}
              className="absolute inset-0 w-full h-[120%] object-cover grayscale-[15%]"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#0a0805] via-transparent to-transparent" />
            <p className="absolute bottom-5 left-5 font-grotesk uppercase tracking-[0.3em] text-xs text-[#f3ead6]/80">
              Portrait coming soon
            </p>
          </div>
        </div>

        <div className="lg:col-span-7 order-1 lg:order-2">
          <motion.p
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="font-grotesk uppercase tracking-[0.35em] text-xs text-[#d8ab4e] mb-6"
          >
            The Author
          </motion.p>
          <motion.h2
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, delay: 0.1 }}
            className="font-display text-5xl sm:text-7xl leading-[0.9] mb-10"
          >
            {SITE.author}
          </motion.h2>
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="space-y-6 max-w-2xl font-body text-lg md:text-xl text-[#c3b79b] leading-relaxed"
          >
            {SITE.authorBio.map((p, i) => (
              <p key={i}>{p}</p>
            ))}
            <p className="font-display italic text-[#f2c968] text-xl">
              “{SITE.dedication}”
            </p>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default AuthorSection;
